import { z } from "zod";

export interface RegisterOrganizationDto {
  email: string;
  organizationName: string;
  website?: string;
  organizationEmail?: string;
  phone?: string;
  address?: string;
  /** The package the organization starts on; its values can be edited after. */
  packageKey: string;
}

export const registerOrganizationSchema = z.object({
  email: z.string().email("Invalid email address").min(1, "Email is required"),
  organizationName: z.string().min(1, "Organization name is required"),
  website: z.string().url("Invalid URL format").optional().or(z.literal("")),
  organizationEmail: z.string().email("Invalid email address").optional().or(z.literal("")),
  phone: z.string().optional(),
  address: z.string().optional(),
  packageKey: z.string().min(1, "Choose a package")
});

export type RegisterOrganizationFormData = z.infer<typeof registerOrganizationSchema>;
